import { request } from './Api';
import { recordActivity } from './ActivityService';

export async function login(email, password) {
    const response = await request('/api/admin/auth/login', {
        method: 'POST',
        auth: false,
        body: { email, password }
    });

    const data = response.data;
    if(!data?.accessToken) {
        throw new Error('Login response did not include an access token.');
    }

    recordActivity({
        type: 'auth',
        action: 'Logged in',
        userUuid: data.user?.uuid || data.uuid
    });
    return data;
}
